"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_AUTHORIZATION_CODE_ERROR = exports.AUTHORIZE_ERROR = void 0;
var AUTHORIZE_ERROR = 'AUTHORIZE_ERROR';
exports.AUTHORIZE_ERROR = AUTHORIZE_ERROR;
var DELETE_AUTHORIZATION_CODE_ERROR = 'DELETE_AUTHORIZATION_CODE_ERROR';
exports.DELETE_AUTHORIZATION_CODE_ERROR = DELETE_AUTHORIZATION_CODE_ERROR;